/** The one place a plan's price, length and Paddle price id live.
 *  The website carries its own copy (website#7); keep the two in step. */
export type PaidPlan = 'trip_pass' | 'monthly' | 'yearly';

export const PLANS: Record<PaidPlan, { priceUsd: number; days: number; paddlePriceId: string }> = {
  yearly: { priceUsd: 29.99, days: 365, paddlePriceId: 'pri_01kmwrgj1g52cp3sx480carjcq' },
  monthly: { priceUsd: 4.99, days: 30, paddlePriceId: 'pri_01kmwrjpgh6sf66mwjp9a4nsgf' },
  trip_pass: { priceUsd: 3.99, days: 7, paddlePriceId: 'pri_01kmwrp0sycz0zerz734rk4v14' },
};

export function planPrice(plan: PaidPlan): string {
  return `$${PLANS[plan].priceUsd.toFixed(2)}`;
}
